function updateNextButtonState(stepIndex) {
  const steps = document.querySelectorAll('.trade-in-product__step');
  const nextBtn = document.querySelector('.trade-in-product__stepper-btn--next');

  const step = steps[stepIndex];
  const selected = step?.querySelector('input:checked');
  if (nextBtn) {
    nextBtn.disabled = !selected;
  }
}

function setupTradeInAnswerSelection() {
  const answers = document.querySelectorAll(".trade-in-product__step-answer");
  if (!answers?.length) return;

  answers.forEach((answer) => {
    const label = answer.querySelector("label");
    const inputId = label?.htmlFor;
    if (!inputId) return;

    const input = document.getElementById(inputId);
    if (!input) return;

    label.addEventListener("click", (e) => {
      e.preventDefault();

      const groupName = input.name;
      if (!groupName) return;

      const groupInputs = document.getElementsByName(groupName);
      if (!groupInputs?.length) return;

      groupInputs.forEach((el) => {
        el.checked = false;

        const answerDiv = el
          ?.closest(".trade-in-product__step-answer-wrapper")
          ?.querySelector(".trade-in-product__step-answer");

        answerDiv?.classList.remove("trade-in-product__step-answer--selected");
      });

      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));

      answer.classList.add("trade-in-product__step-answer--selected");

      const stepIndex = [...document.querySelectorAll('.trade-in-product__step')].findIndex(step =>
        step.classList.contains('trade-in-product__step--active')
      );
      updateNextButtonState(stepIndex);
    });
  });
}

function setupTradeInStepper() {
  const steps = document.querySelectorAll('.trade-in-product__step');
  const nextBtn = document.querySelector('.trade-in-product__stepper-btn--next');
  const prevBtn = document.querySelector('.trade-in-product__stepper-btn--prev');
  const progressFill = document.querySelector('.trade-in-product__progress-fill');
  const resultSection = document.querySelector('.trade-in-summary__section');

  const activeStep = document.querySelector('.trade-in-product__step--active');
  let currentStepIndex = activeStep ? Number(activeStep.getAttribute('data-step')) : 0;
  const lastStepIndex = steps.length - 1;
  let hasSubmitted = false;

  function updateProgressBar(index) {
    const percent = ((index + 1) / steps.length) * 100;
    if (progressFill) progressFill.style.width = `${percent}%`;
  }

  function updateStep(newIndex) {
    if (newIndex < 0 || newIndex >= steps.length) return;

    const currentStepEl = document.querySelector(`.trade-in-product__step[data-step="${currentStepIndex}"]`);
    const newStepEl = document.querySelector(`.trade-in-product__step[data-step="${newIndex}"]`);

    currentStepEl?.classList.remove('trade-in-product__step--active');
    newStepEl?.classList.add('trade-in-product__step--active');
    currentStepIndex = newIndex;

    prevBtn.disabled = currentStepIndex === 0;

    if (resultSection && !hasSubmitted) {
      resultSection.style.display = 'none';
    }

    updateProgressBar(currentStepIndex);
    updateNextButtonState(currentStepIndex);
  }

  function showResults() {
    hasSubmitted = true;
    if (resultSection) {
      resultSection.style.display = 'block';
    }

    document.querySelector('.trade-in-product')?.classList.add('trade-in-product--showing-result');

    nextBtn.disabled = true;
    prevBtn.disabled = true;
  }

  nextBtn?.addEventListener('click', () => {
    if (currentStepIndex === lastStepIndex) {
      showResults();
    } else {
      updateStep(currentStepIndex + 1);
    }
  });

  prevBtn?.addEventListener('click', () => {
    updateStep(currentStepIndex - 1);
  });

  updateStep(currentStepIndex);
}

setupTradeInAnswerSelection();
setupTradeInStepper();